module.exports = __webpack_public_path__ + "img/tax_icon.b46dfbc5.svg";